import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.09766 10.7809V10.3226C9.09766 8.55067 10.5341 7.11426 12.306 7.11426C14.0779 7.11426 15.5143 8.55067 15.5143 10.3226V10.7809L12.306 13.5309V15.8226",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.3047 17.1973V19.0306",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M2.22266 12.6141C2.22266 15.2884 3.28501 17.8531 5.176 19.7441C7.06699 21.6351 9.63172 22.6974 12.306 22.6974C14.9803 22.6974 17.545 21.6351 19.436 19.7441C21.327 17.8531 22.3893 15.2884 22.3893 12.6141C22.3893 9.93983 21.327 7.3751 19.436 5.48411C17.545 3.59311 14.9803 2.53076 12.306 2.53076C9.63172 2.53076 7.06699 3.59311 5.176 5.48411C3.28501 7.3751 2.22266 9.93983 2.22266 12.6141Z",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1)
  ])))
}
export default { render: render }